import React from 'react';
import { Link } from 'react-router-dom';
import { FlowerIcon, GemIcon, SkullIcon } from 'lucide-react';
type QuickLinksProps = {
  compact?: boolean;
};
const links = [{
  to: '/portfolio',
  title: 'See The Skills',
  text: 'Check out the skills of our fellow Tattoo Artists.',
  Icon: SkullIcon
}, {
  to: '/book-now',
  title: 'Appointment Request',
  text: 'Are you excited to get Tattooed or Pierced? Get yourself a Tattoo or Piercing, by Requesting to Schedule an Appointment.',
  Icon: GemIcon
}, {
  to: '/artists',
  title: 'Meet The Artists',
  text: 'Do you want to know who’s behind the Art? Meet the people behind the skills.',
  Icon: FlowerIcon
}];
export function QuickLinks({
  compact = false
}: QuickLinksProps) {
  return <div className="mx-auto grid max-w-6xl gap-12 px-6 md:grid-cols-3 md:gap-8" data-id="element-198" data-mp="280cj95w5thto">
      {links.map(({
      to,
      title,
      text,
      Icon
    }) => <Link key={to} to={to} className="group flex flex-col items-center text-center" data-id="element-199" data-mp="232ub3hpyv6mq">
          <Icon className={`${compact ? 'h-14 w-14' : 'h-24 w-24'} transition-transform duration-200 ease-out group-hover:-translate-y-1`} strokeWidth={1} aria-hidden="true" data-id="element-200" data-mp="24mnx026h2jsu" />
          <h3 className="mt-6 font-slab text-base font-bold uppercase tracking-[0.25em] group-hover:underline group-hover:underline-offset-8" data-id="element-201" data-mp="1volrpafph4zr">
            {title}
          </h3>
          {!compact && <p className="mt-4 max-w-xs leading-relaxed text-ink-muted" data-id="element-202" data-mp="2od103e4c0p24">{text}</p>}
        </Link>)}
    </div>;
}